"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateItemInputsDTO = exports.TemplateItemDTO = exports.TemplateSectionDTO = exports.TemplateDTO = void 0;
class TemplateDTO {
    id;
    name;
    information;
    content;
    createdAt;
    mutable;
}
exports.TemplateDTO = TemplateDTO;
class TemplateSectionDTO {
    name;
    content;
}
exports.TemplateSectionDTO = TemplateSectionDTO;
class TemplateItemDTO {
    component;
    selector;
    inputs;
}
exports.TemplateItemDTO = TemplateItemDTO;
class TemplateItemInputsDTO {
    editable;
    placeHolder;
    choice;
    default;
    value;
    type;
    required = false;
}
exports.TemplateItemInputsDTO = TemplateItemInputsDTO;
